module.exports = __webpack_public_path__ + "static/media/title.b7a24c89.png";